import React from 'react';
import classNames from 'classnames';
import { IBottomDetailsProps } from './BottomDetails.types';
import styles from './BottomDetails.module.css';

export const BottomDetails: React.FC<IBottomDetailsProps> = ({ children, className }: IBottomDetailsProps) => {
  return <div className={classNames(styles.bottomDescription, className)}>{children}</div>;
};
